import React from 'react';
import { useApi } from 'hooks/SwrCustom';
import AfasFooterActions from '../components/AfasFooterActions';
import AfasGrid from '../components/AfasGrid';
import AfasListToolbar from '../components/AfasListToolbar';
import { useAfasContext } from '../context/AfasContext';
import { AFAS_HISTORIE_COLUMNS, AFAS_MOCK_HISTORIE_ROWS } from '../constants';
import { Card, CardBody, Col, Row } from 'reactstrap';
import Loader from "react-loaders";

const AfasHistoriePage = () => {
    const { communityId, historiePeriod } = useAfasContext();

    const periodQuery = historiePeriod ? `&period=${historiePeriod}` : '';
    const swrKey = communityId
        ? `afas/historie?community_id=${communityId}${periodQuery}`
        : null;

    const { data: response, isLoading } = useApi(swrKey);
    const rows = response?.data?.items ?? [];
    const totalCount = response?.totalCount || 0;

    return (
        <Row>
            <Col md="12" lg="12">
                <Card className="main-card mb-3">
                    <CardBody className="p-3 table-responsive">
                        <div className="afas-list-page afas-list-page--toolbar-in-footer">
                            <AfasGrid
                                className="afas-grid--historie shadow-none"
                               columns={AFAS_HISTORIE_COLUMNS}
                                totalCount={totalCount}
                                rows={rows}
                                emptyMessage={
                                    isLoading
                                        ? <Loader
                                            type="ball-grid-pulse"
                                            className="mt-3 d-flex mx-auto justify-content-center"
                                        />
                                        : !communityId
                                            ? 'Selecteer een organisatie'
                                            : 'Geen historie gevonden'
                                }
                            />

                            <AfasFooterActions showActions={false}>
                                <AfasListToolbar compact showPeriod />
                            </AfasFooterActions>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default AfasHistoriePage;
